<template>
  <div>
    <div class="ship-info" @click="shipChange">
      <img class="icon-ship" src="../../assets/icons/icon_ship2.png" alt="">
      <span>{{shipName}}</span>
      <img class="icon-arrow-down" src="../../assets/icons/icon_arrow_down.png" alt="">
    </div>
    <div class="shop-info">
      <div
        v-for="(item, index) in categories"
        :key="`categories${index}`"
        :class="['shop-tab', {cur: index === categoryActive}]"
        :data-index="index"
        @click="categoryConfirm(item, index)">
        <span>{{item.Text}}</span>
      </div>
    </div>
    <div :class="['filter-info', {fixed: fixedFilter === true}]" ref="filterPart">
      <div @click="filterChange('cid')">{{cateName}}<img class="icon-arrow-down" src="../../assets/icons/icon_downArrow.png" alt=""></div>
      <div @click="filterChange('mid')">{{brandName}}<img class="icon-arrow-down" src="../../assets/icons/icon_downArrow.png" alt=""></div>
      <div v-show="$store.state.bindTicket.bookingId" @click="filterChange('orderBy')">{{orderName}}<img class="icon-arrow-down" src="../../assets/icons/icon_downArrow.png" alt=""></div>
    </div>
    <!-- 产品列表 -->
    <!-- <div class="product-list position-box" v-if="productList.length">
      <vue-better-scroll class="wrapper"
                         ref="scroll"
                         :pullUpLoad="pullUpLoadObj"
                         :startY="parseInt(startY)"
                         @pullin-up="onPullingUp">
          <product-list :list="productList.length ? productList : []" />
      </vue-better-scroll>
    </div> -->
    <div class="product-list" v-if="productList.length">
      <product-list :list="productList.length ? productList : []" />
      <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler" class="loading">
        <div slot="spinner">
          <img src="../../assets/icons/loading.png">
          <p>加载中...</p>
        </div>
        <div slot="no-more">已经到底了哟</div>
        <div slot="no-results">已经到底了哟，看看其他品类的商品吧</div>
      </infinite-loading>
    </div>
    <no-data :type="noDataType" v-show="productList.length > 0" v-else />
    <!-- 查询船只 -->
    <custom-picker :visible.sync="shipChooseShow" @change="shipCodeLocal = arguments[0]" />
    <!-- 商品分类过滤 -->
    <filter-picker :title="pickerTitle" :columns="subCategoryList" :visible.sync="filterChooseShow" @change="filterConfirm"/>
    <!-- 品牌过滤 -->
    <filter-picker :title="pickerTitle" :columns="availableManufacturers" :visible.sync="brandChooseShow" @change="brandConfirm"/>
    <!-- 价格排序 -->
    <filter-picker :title="pickerTitle" :columns="orderList" :visible.sync="orderChooseShow" @change="orderConfirm"/>
  </div>
</template>

<script>
import { shipList } from '@/utils/dict'
import ProductList from './ProductList'
import CustomPicker from '@/components/CustomPicker'
import FilterPicker from '@/components/FilterPicker'
import api from '@/api'
import { showLoading, hideLoading, showAlert } from '@/utils/tools'
import NoData from '@/components/NoData'
import { mapState } from 'vuex'
// import VueBetterScroll from 'vue2-better-scroll'
import InfiniteLoading from '@/utils/vue-infinite-loading'

export default {
  name: 'BookingNormalList',

  props: {
    type: {
      type: String
    },
    query: {
      type: String,
      default: ''
    }
  },

  components: {
    ProductList,
    CustomPicker,
    FilterPicker,
    // VueBetterScroll,
    InfiniteLoading,
    NoData
  },

  data () {
    return {
      shipList,
      shipChooseShow: false,
      filterChooseShow: false,
      brandChooseShow: false,
      orderChooseShow: false,
      shipCodeLocal: shipList[0].value,
      cateName: '商品分类',
      brandName: '品牌',
      orderName: '价格',
      q: this.query,
      cid: null,
      mid: null,
      orderBy: 0,
      pagenumber: 1,
      swiperOption: {
        freeMode: true,
        slidesPerView: 'auto',
        spaceBetween: 11,
        on: {
          click: swiper => {
            this.classifyActive = Number(swiper.target.attributes['data-index'].nodeValue)
          }
        }
      },
      classifyActive: 0,
      categoryActive: -1,
      productList: [],
      shopList: [],
      availableCategories: [],
      categories: [],
      availableManufacturers: [],
      subCategoryList: [],
      orderList: [
        { Disabled: false, Group: null, Selected: false, Text: '由低到高', Value: '10' },
        { Disabled: false, Group: null, Selected: false, Text: '由高到低', Value: '11' }
      ],
      pickerTitle: '',
      fixedFilter: false,
      infiniteId: 0
      // scrollbarObj: {
      //   fade: true
      // },
      // // 这个配置用于做上拉加载功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启上拉加载，可以配置离底部距离阈值（threshold）来决定开始加载的时机
      // pullUpLoadObj: {
      //   threshold: 900,
      //   txt: {
      //     more: '加载中...',
      //     noMore: '没有更多商品了'
      //   }
      // },
      // startY: 0, // 纵轴方向初始化位置
      // scrollToX: 0,
      // scrollToY: 0,
      // scrollToTime: 700
    }
  },

  watch: {
    // type: {
    //   handler () {
    //     this.shipCodeLocal = this.bookingPage ? this.bookingPage.shipCode : shipList[0].value
    //     this.getProductList()
    //   },
    //   immediate: true
    // },
    query: {
      handler () {
        this.q = this.query
        this.getProductList()
      },
      immediate: false
    },
    shipCode () {
      this.getProductList()
    }
  },

  computed: {
    ...mapState(['bookingPage', 'bindTicket']),
    shipName () {
      // window.console.log(this.shipCode)
      return shipList.find(x => x.value === this.shipCode).name
    },
    shipCode () {
      return this.bindTicket && this.bindTicket.shipCode ? this.bindTicket.shipCode : this.shipCodeLocal
    },
    subCategories () {
      return this.subCategoryList.map(x => x.value)
    },
    noDataType () {
      return '3'
    }
  },

  async mounted () {
    this.checkSeoName()
    // this.getProductList()
    window.addEventListener('scroll', this.watchScroll)
    // this.onPullingUp()
  },

  methods: {
    shipChange () {
      if (this.bindTicket) return
      this.shipChooseShow = true
    },
    watchScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      // var topH = this.$refs.filterPart.getBoundingClientRect().top
      // window.console.log(topH)
      var topH = 413
      if (scrollTop > topH) {
        this.fixedFilter = true
      } else {
        this.fixedFilter = false
      }
    },
    filterChange (type) {
      switch (type) {
        case 'cid':
          this.filterChooseShow = true
          this.pickerTitle = '商品分类'
          break
        case 'mid':
          this.brandChooseShow = true
          this.pickerTitle = '品牌'
          break
        case 'orderBy':
          this.orderChooseShow = true
          this.pickerTitle = '价格'
          break
        default:
          break
      }
    },
    async checkSeoName () {
      showLoading()
      const path = this.$route.path.split('/')
      let seoName = path[path.length - 1]
      const { errCode, data } = await api.checkSeoName(seoName)
      if (errCode === 0) {
        let entityName = data.EntityName
        if (entityName === 'Category') {
          this.cid = data.EntityId
          if (seoName === 'cosmetic') {
            this.categoryActive = 0
          } else if (seoName === 'dutyfree') {
            this.categoryActive = 1
          }
        }
      }
      this.getProductList()
    },
    async getProductList () {
      showLoading()
      this.pagenumber = 1
      const { errCode, errMsg, data } = await api.getProductSearch(this.q, this.cid, this.mid, this.orderBy, this.shipCode, this.pagenumber)
      if (errCode === 0) {
        this.infiniteId += 1
        this.classifyActive = this.bookingPage ? this.bookingPage.classifyActive : 0
        this.$store.commit('storeBookingPageData', '')
        this.productList = data.SMProducts
        this.availableCategories = data.AvailableCategories
        this.categories = data.Categories
        this.availableManufacturers = data.AvailableManufacturers
        this.subCategoryList = data.SubCategories
        // this.orderList = data.PagingFilteringContext.AvailableSortOptions.filter(function (item) {
        //   return item.Text !== '条件' && item.Text !== '拼音名: 升序' && item.Text !== '拼音名: 倒序'
        // })
      } else {
        showAlert(errMsg || '页面数据获取失败，请稍后重试')
      }
      hideLoading()
      return data
    },
    categoryConfirm (val, index) {
      this.cid = parseInt(val.Value)
      this.categoryActive = index
      this.q = ''
      this.cateName = '商品分类'
      this.brandName = '品牌'
      this.getProductList()
      this.$router.replace('/' + val.SeName)
    },
    filterConfirm (val) {
      if (val.Text === '全部') {
        this.cateName = '商品分类'
      } else {
        this.cateName = val.Text
      }
      this.cid = parseInt(val.Value)
      this.q = ''
      this.getProductList()
      this.$router.replace('/' + val.SeName)
      this.scrollToFilter()
    },
    brandConfirm (val) {
      if (val.Text === '全部') {
        this.brandName = '品牌'
      } else {
        this.brandName = val.Text
      }
      this.mid = parseInt(val.Value)
      this.q = ''
      this.getProductList()
      this.scrollToFilter()
    },
    orderConfirm (val) {
      if (val.Text === '全部') {
        this.orderName = '价格'
      } else {
        this.orderName = val.Text
      }
      this.orderBy = parseInt(val.Value)
      this.getProductList()
      this.scrollToFilter()
    },
    scrollToFilter () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      var topH = 485
      if (scrollTop > topH) {
        window.scrollTo(0, topH)
      }
    },
    async infiniteHandler ($state) {
      this.pagenumber += 1
      const { errCode, errMsg, data } = await api.getProductSearch(this.q, this.cid, this.mid, this.orderBy, this.shipCode, this.pagenumber)
      // window.console.log(data)
      if (errCode === 0 && data.SMProducts.length) {
        this.infiniteId += 1
        this.productList.push(...data.SMProducts)
        $state.loaded()
      } else {
        $state.complete()
        if (errCode !== 0) {
          showAlert(errMsg || '页面数据获取失败，请稍后重试')
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.filter-info.fixed {
  position: sticky;
  top: 120px;
  width: 710px;
  z-index:90;
}
.ship-info {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 108px;
  font-size: 30px;
  color: @main-color;
  background-color: #fff;
  border-bottom: 1px #eaeaea solid;
  .icon-ship {
    width: 36px;
    margin-right: 8px;
  }
  .icon-arrow-down {
    width: 21px;
    margin-left: 15px;
  }
}
.shop-info {
  display: flex;
  .shop-tab {
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: space-around;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 108px;
    font-size: 30px;
    background-color: #fff;
    width: 3.75rem;
    border-bottom: 1px #eaeaea solid;
    color: #999;
  }
  .shop-tab.cur {
    border-bottom: 3px #1174b8 solid;
    color: #333;
  }
}
.filter-info {
  display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: space-around;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 108px;
    font-size: 30px;
    background-color: #fff;
    border-bottom: 1px #eaeaea solid;
    color: #333;
    padding: 0px 20px;
    .icon-arrow-down {
      width: 19px;
      margin-left: 15px;
    }
}
.product-classify {
  width: 100%;
  padding: 15px 0 45px;
  .classify-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: 48px;
    padding: 0 34px;
    border-radius: 24px;
    font-size: 26px;
    color: #1174b8;
    background-color: #fff;
    &.cur {
      .btn-linear-gradient;
      color: #333;
    }
  }
}
.product-list {
  padding: 30px 50px 70px;
}
.position-box {
  top: 40px;
  left: 0;
  right: 0;
  bottom: 0;
  height: 1000px;
}
.loading {
  font-size: 24px;
  img {
    width: 60px;
  }
}
// .wrapper {
//   padding: 0px;
// }
</style>
